<template>
<div
  :class="[
    't-phonenumber',
    {'t-phonenumber--focused': focused, 't-phonenumber--filled': filled}
  ]"
>
  <div class="t-phonenumber__wrapper">
    <t-flag-icon class="t-phonenumber__flag" :iso3166_1="normalizedCountryCode" />
    <div class="t-phonenumber__number">
      <t-input
        native-type="tel"
        class="t-phonenumber__input"
        :value="phonenumber.formatted"
        @input="handleInput"
        @focus="toggleFocus"
        @blur="toggleFocus"
      />
    </div>
  </div>
</div>
</template>

<script>
import { AsYouType } from 'libphonenumber-js';
import { TFlagIcon } from '../TIcon';
import TInput from '../TInput';

export default {
  name: 't-phonenumber',

  props: {
    value: {
      type: String,
      required: false,
      default: undefined,
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  mounted() {
    if (this.value) {
      this.handleInput(this.value);
    }
  },

  data() {
    return {
      phonenumber: {
        countryCode: (new Intl.Locale(navigator.language))?.region ?? 'DE',
        e164: '',
        formatted: '',
      },
      focused: false,
    };
  },

  computed: {
    filled() {
      return !!this.phonenumber.e164;
    },
    normalizedCountryCode() {
      return this.phonenumber.countryCode.toLowerCase();
    },
  },

  methods: {
    toggleFocus() {
      this.focused = !this.focused;
    },

    handleInput(value) {
      if (!value) {
        this.phonenumber.e164 = '';
      }
      const ayt = new AsYouType(this.phonenumber.countryCode);
      this.phonenumber.formatted = ayt.input(value);

      if (ayt.getNumber()?.country) {
        this.phonenumber.e164 = ayt.getNumber()?.number;
        this.phonenumber.countryCode = ayt.getNumber()?.country;
      }
    },
  },

  components: {
    TFlagIcon,
    TInput,
  },

  watch: {
    'phonenumber.e164': function phoneNumberE164(val) {
      if (val) {
        this.$emit('input', val);
        this.$emit('change', val);
      }
    },

    value(val) {
      this.handleInput(val);
    },
  },
};
</script>
